<template lang="html">
<transition name="bg">
  <div class="main" v-show="show.spaceList">
    <div class="main-bg" @click="closeList"></div>
    <transition name="side">
      <div class="work-space" v-show="show.spaceList">
        <div class="top">
          <span class="selName">{{message.Sl160}}:</span>
          <span class="selWs">{{name}}</span>
        </div>
        <transition name="fade" mode="out-in">
          <i @click="button()"  v-if="buttonShow" class="material-icons refresh">autorenew</i>
        </transition>
        <VuePerfectScrollbar @settings="settings" class="cell-body">
          <div class="cell" v-if="user.role === 0">
            {{message.Sl126}}
          </div>
          <span @click='dialogA=true' v-if="user.role === 0">
            <comp-space
              :type="'add'"
            ></comp-space>
          </span>
          <transition-group name="fade">
            <comp-space
              @toSpace="changeSpace(index, 'creat')"
              v-for="(space, index) in mySpaces"
              :key="space.id"
              :type="space.type"
              :name="space.name"
              :id="space.id"
              :members="space.members"
              :imgUrl="space.imgUrl"
              :creater="space.creater"
            ></comp-space>
          </transition-group>

          <el-dialog
            :title="message.Sl231"
            :visible.sync="dialogA"
            width="520px"
            append-to-body
          >
            <el-form :model="form">
            <el-form-item :label="message.Fl105" :label-width="formLabelWidth">
              <el-input style="width:100%;max-width:260px" v-model.trim="form.name" auto-complete="off" :maxlength="32"></el-input>
            </el-form-item>
            <el-form-item :label="message.Fl123" :label-width="formLabelWidth" v-if="zones.length > 1">
              <el-select v-model="zoneId" style="width:100%;max-width: 260px">
               <el-option
                 v-for="item in zones"
                 :key="item.id"
                 :label="item.label"
                 :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" style="width:80px" size='medium' @click="addProject()">{{message.Fl127}}</el-button>
              <el-button style="width:80px" size='medium' @click="dialogA = false">{{message.Fl101}}</el-button>
            </div>
          </el-dialog>
          <div class="cell" v-if="otherSpaces.length !==0">
            {{message.Sl120}}
          </div>
          <transition-group name="fade"
            v-if="otherSpaces.length !==0"
          >
            <comp-space
              v-for="(space, index) in otherSpaces"
              @toSpace="changeSpace(index, 'join')"
              :key="space.id"
              :type="space.type"
              :name="space.name"
              :id="space.id"
              :members="space.members"
              :imgUrl="space.imgUrl"
              :creater="space.creater"
            ></comp-space>
          </transition-group>
        </VuePerfectScrollbar>
      </div>
    </transition>
  </div>
</transition>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import CompSpace from '@/components/box/workSpace.vue'
import router from '@/router'

export default {
  computed: {
    ...mapGetters({
      show: 'show',
      updateEl: 'updateEl',
      space: 'space',
      user: 'user'
    })
  },
  components: {
    CompSpace,
    VuePerfectScrollbar
  },
  watch: {
    updateEl: function (val) {
      if (val === 'workspaceList') {
        this.update()
        this.$store.dispatch('updateEl', '')
      }
    },
    dialogA: function (val) {
      if (val) {
        this.$api.getZonesId(response => {
          this.zones = []
          for (var i = 0; i < response.length; i++) {
            this.zones.push({
              label: response[i].name,
              value: response[i].id
            })
          }
          this.zoneId = this.zones[0].value
        })
      }
    },
    'space.id': function (val, oldVal) {
      if (val !== oldVal) {
        this.getWorkspaceName()
      }
    }
  },
  data () {
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Fl105: this.$lang.ui.form.l105,
        Fl127: this.$lang.ui.form.l127,
        Sl100: this.$lang.ui.system.l100,
        Sl101: this.$lang.ui.system.l101,
        Sl231: this.$lang.ui.system.l231,
        Sl119: this.$lang.ui.system.l119,
        Sl120: this.$lang.ui.system.l120,
        Sl126: this.$lang.ui.system.l126,
        Fl123: this.$lang.ui.form.l123,
        Sl160: this.$lang.ui.system.l160,
        Nl106: this.$lang.ui.notice.l106
      },
      buttonShow: true,
      no: 0,
      dialogA: false,
      form: {
        name: '',
        id: '1'
      },
      formLabelWidth: '120px',
      mySpaces: [],
      otherSpaces: [],
      settings: {
        maxScrollbarLength: 0
      },
      zones: [],
      zoneId: 'default',
      name: ''
    }
  },
  mounted () {
    this.update()
  },
  methods: {
    update () {
      if (!localStorage.getItem('token')) {
        return
      }
      this.$store.dispatch('newPkg', [])
      this.projectList().then(() => {
        var data = ''
        var allList = this.mySpaces.concat(this.otherSpaces)
        // 获取文件信息
        var index = 0
        const projectId = localStorage.getItem('projectId')
        for (var i = 0; i < allList.length; i++) {
          if (projectId === allList[i].id) {
            index = i
            break
          }
        }
        if (allList.length > 0) {
          data = {
            id: allList[index].id,
            name: allList[index].name,
            imgUrl: allList[index].imgUrl
          }
          this.$store.dispatch('addSpace', data)
          localStorage.setItem('projectId', data.id)
          localStorage.setItem('projectName', data.name)
          localStorage.setItem('projectUrl', data.imgUrl)
          this.$emit('workspacesList', true)
          this.space.id = data.id
          this.getWorkspaceName()
        } else {
          router.push({ path: '/app/initial' })
        }
      })
    },
    closeList () {
      this.$store.dispatch('showSpacelist', false)
    },
    getProjectId () {
      return new Promise((resolve, reject) => {
        // if (sessionStorage.getItem('downloadToken')) {
        //   var token = sessionStorage.getItem('downloadToken')
        //   this.$api.getDownloadFilesInfo(token, response => {
        //     if (response !== 1) {
        //       sessionStorage.setItem('downloadId', response.data.pkg_download.pkg_info.id)
        //       resolve(response.data.pkg_download.pkg_info.project_id)
        //     } else {
        //       resolve('')
        //     }
        //   })
        // } else {
        //   var projectId = localStorage.getItem('projectId')
        //   resolve(projectId)
        // }
        var projectId = localStorage.getItem('projectId')
        resolve(projectId)
      })
    },
    projectList () {
      return new Promise((resolve, reject) => {
        this.no = 0
        this.mySpaces = []
        this.otherSpace = []
        this.$http
          .get('/cydex/api/v1/projects', {
            params: {
              type: 1
            }
          })
          .then(response => {
            this.mySpaces = []
            if (response.data.projects) {
              for (var i = 0; i < response.data.projects.length; i++) {
                this.mySpaces.push({
                  type: 'creat',
                  name: response.data.projects[i].name,
                  id: response.data.projects[i].id,
                  members: response.data.projects[i].members_num,
                  imgUrl: response.data.projects[i].pic_url,
                  creater: response.data.projects[i].creater
                })
              }
            }
            this.no = this.no + 1
            if (this.no === 2) {
              resolve()
            }
          })
        this.$http
          .get('/cydex/api/v1/projects', {
            params: {
              type: 2
            }
          })
          .then(response => {
            this.otherSpaces = []
            if (response.data.projects) {
              for (var i = 0; i < response.data.projects.length; i++) {
                this.otherSpaces.push({
                  type: 'join',
                  name: response.data.projects[i].name,
                  id: response.data.projects[i].id,
                  members: response.data.projects[i].members_num,
                  imgUrl: response.data.projects[i].pic_url,
                  creater: response.data.projects[i].creater
                })
              }
            }
            this.no = this.no + 1
            if (this.no === 2) {
              resolve()
            }
          })
      })
    },
    addProject () {
      this.$http
        .post('/cydex/api/v1/projects', {
          name: this.form.name,
          zone_id: this.zoneId
        })
        .then(response => {
          this.dialogA = false
          this.form.name = ''
          this.update()
          this.$message({
            message: this.$lang.ui.prompt.l145,
            type: 'success',
            duration: 3000
          })
        })
    },
    button () {
      this.buttonShow = false
      setTimeout(() => {
        this.buttonShow = true
      }, 1000)
      this.update()
    },
    // zoneList () {
    //   this.$api.getZonesId(response => {
    //     if (response.length) {
    //       for (var i = 0; i < response.length; i++) {
    //         this.zones.push({
    //           value: response[i].id,
    //           label: response[i].name
    //         })
    //       }
    //       if (response.length === 1) {
    //         this.form.id = response[0].id
    //       }
    //     }
    //   })
    // },
    changeSpace (id, type) {
      if (type === 'creat') {
        var data = {
          id: this.mySpaces[id].id,
          name: this.mySpaces[id].name,
          imgUrl: this.mySpaces[id].imgUrl
        }
      } else {
        data = {
          id: this.otherSpaces[id].id,
          name: this.otherSpaces[id].name,
          imgUrl: this.otherSpaces[id].imgUrl
        }
      }
      this.$store.dispatch('addSpace', data)
      localStorage.setItem('projectId', data.id)
      localStorage.setItem('projectName', data.name)
      localStorage.setItem('projectUrl', data.imgUrl)
      this.$router.push('/app/workspace')
    },
    getWorkspaceName () {
      this.$api.getProject(this.space.id, response => {
        this.id = response.project.id
        this.name = response.project.name
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background-color: transparent;
}
.main-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.3;
}
.work-space {
  z-index: 3;
  position: fixed;
  width: 260px;
  background-color: #fff;
  top: 0;
  bottom: 0;
  right: 1px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  padding-bottom: 10px;
  overflow: hidden;
  border-left: 1px solid #f0f0f0;
}
.top {
  z-index: 3;
  height: 58px;
  line-height: 58px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
  width: 80%;
  padding-left: 15px;
  background-color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-body {
  z-index: 2;
  position: absolute;
  top: 58px;
  bottom: 0;
  left: 0;
  right: 0;
}
.cell {
  width: 100%;
  min-width: 220px;
  padding: 15px 15px;
  overflow: hidden;
  min-height: 46px;
}
.side-enter-active,
.side-leave-active {
  transition: width 0.28s;
}
.side-enter,
.side-leave-to {
  width: 0px;
}
.bg-leave-active {
  transition: opacity 0.24s;
}
.bg-leave-to {
  opacity: 0;
}
.refresh {
  position: absolute;
  cursor: pointer;
  color: rgba(117, 117, 117, 0.7);
  right: 15px;
  top: 17px;
}
.refresh:hover {
  color: #212121;
}
// .selWs {
//   display: inline-block;
//   width: 45%;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   margin-right: 30px;
//   float: right;
// }
// .selName {
//   display: inline-block;
//   width: 60px;
//   float: left;
// }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
